var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProductPlaceholder = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 82 82",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#product-placeholder_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M62.77 13.594c9.593 2.737 13.692 8.115 10.881 17.966l-9.804 34.355c-2.787 9.768-9.39 12.539-18.9 9.825l-25.469-7.268c-3.886-1.109-7.655-2.632-9.876-6.13C7.3 58.818 7.31 54.077 8.42 50.186l9.71-34.024c1.157-4.056 3.661-7.817 7.524-9.759 3.733-1.8 7.596-1.234 11.483-.125l25.634 7.315Zm-39.218 17.73-5.386 18.874c-.615 2.152-.733 4.446.39 6.467 1.18 2.127 3.33 2.741 5.563 3.378l21.335 6.088c5.127 1.463 8.291.686 9.87-4.503l5.604-19.64-37.376-10.665ZM36.71 15.92c-5.622-1.605-8.67-.325-10.324 5.47l-.26.91 37.377 10.665.26-.91c1.63-5.712-.178-8.466-5.8-10.07L36.71 15.92Z",
  fill: "#F4F3F0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "product-placeholder_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h82v82H0z"
})))));
export default SvgProductPlaceholder;